module.exports = __webpack_public_path__ + "static/media/patient-avatar-1.5f7f7690.svg";